<!--订单列表-->
<template>
  <div class="order-item">
    <table class="table-column">
      <tr>
        <div class="order-no"><span>订单编号：</span>{{rows.ordernum}}</div>
        <div><span>创建时间：</span>{{ timestampToTime(rows.applictionTime) }}</div>
      </tr>
    </table>
    <table class="table-enable">
      <tr>
        <td class="first-td">
          <div class="goods-image">
            <el-avatar :src="rows.image" :size="75" shape="square"/>
          </div>
          <div class="price-box">
            <p class="SourceHanSansCN goods-name">{{rows.goodsname}}</p>
            <p class="small-div">
              <span class="SourceHanSansCN price">￥{{rows.price}}</span>
              <span class="SourceHanSansCN amount">×{{rows.amount}}</span>
            </p>
          </div>
        </td>
        <td style="width:12.5%;" class="td-order">
          <p class="SourceHanSansCN">{{rows.consigneeName}}</p>
          <p class="small-p">{{rows.consigneeMobile}}</p>
        </td>
        <td style="width: 12.5%;" class="td-order" v-if="rows.state!=0 && rows.state!=5">
          <p class="SourceHanSansCN">￥{{parseFloat(rows.total).toFixed(2)}}</p>
          <p class="small-p">{{rows.payType}}</p>
        </td>
        <td style="width: 12.5%;" class="td-order" v-else>
          <p class="SourceHanSansCN"></p>
        </td>
        <td style="width: 12.5%;" class="td-order SourceHanSansCN">
          <p class="SourceHanSansCN" style="color: #666666;">
            <span v-if="rows.state == 0">待付款</span>
            <span v-else-if="rows.state == 1">进行中</span>
            <span v-else-if="rows.state == 6">服务中</span>
            <span v-else-if="rows.state == 2">待评价</span>
            <span v-else-if="rows.state == 3">已完成</span>
            <span v-else-if="rows.state == -2">退款中</span>
            <span v-else-if="rows.state == -3">退款成功</span>
            <span v-else-if="rows.state == -4">退款失败</span>
            <span v-else-if="rows.state == 5">交易关闭</span>
          </p>
        </td>
        <td style="border-right: none;width: 12.5%;" class="td-order SourceHanSansCN">
          <el-link type="primary" :underline="false" @click="details(rows.state, rows.id)">详情</el-link>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "order",
  data() {
    return {}
  },
  props:{
    rows:Object
  },
  methods:{
    /*时间戳转换*/
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    /*手机号处理*/
    parseStringToStar(str) {
      let start = str.slice(0, 3)
      let end = str.slice(-4)
      return `${start}****${end}`
    },
    /*订单详情*/
    details(state,id){
      this.$router.push({
        path: "/orderManagement/orderDetails",
        query: {state:state,id:id},
      });
    }
  }
}
</script>
<style scoped>
.order-item >>> .el-link.el-link--primary{
  color: #0077FF;
  font-size: 16px;
}
.order-item >>> .el-link.el-link--primary:hover{
  color: #0077aa;
}
</style>
<style scoped lang="scss">
.table-column{
  display: flex;
  justify-content: start;
  font-size: 16px;
  align-items: center;
  color: #333333;
  background: #f5f5f5;
  border: 1px solid #eeeeee;
  padding-left: 20px;
  height: 40px;
  span{
    cursor: pointer;
  }
  tr{
    display: flex;
    .order-no{
      min-width: 350px;
    }
  }
}
.table-enable{
  width: 100%;
  border-spacing: 0px;
  border: 1px solid #EEEEEE;
  border-top: none;
  tr {
    background: #ffffff;
    td {
      text-align: center;
      font-weight: normal;
      font-size: 16px;
      color: #333333;
      padding: 10px 20px;
      border-right: 1px solid #eeeeee;
    }
    .first-td {
      width: 50%;
      text-align: left;
      font-weight: normal;
      font-size: 16px;
      color: #333333;
      padding: 10px 20px;
      border-right: 1px solid #eeeeee;
      flex: 1;
      .goods-name{
        margin-block-start: 0px;
        margin-block-end: 0px;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 10px;
        cursor: pointer;
        /*overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;*/
      }
      .small-div{
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-block-end: 0px;
        align-items: center;
        cursor: pointer;
        .price{
          font-size: 16px;
          color: #333333;
        }
        .amount{
          color: #999999;
          font-size: 14px;
        }
      }
      .goods-image{
        width: 75px;
        height: 90px;
        float: left;
        padding-right: 10px;
      }
    }
    .td-order{
      cursor: pointer;
      p{
        margin-block-start: 0px;
        margin-block-end: 0px;
        color: #333333;
        font-size: 16px;
        line-height: 24px;

      }
      .small-p{
        font-size: 14px;
      }
    }
  }
}
</style>